import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaseManagementOrgTeamAddRoutingModule } from './case-management-org-team-add-routing.module';
import { CaseManagementOrgTeamAddComponent } from './case-management-org-team-add.component';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    CaseManagementOrgTeamAddComponent
  ],
  imports: [
    CommonModule,
    CaseManagementOrgTeamAddRoutingModule,
    DialogModule,
    SharedModule,
  ],
  exports:[
    CaseManagementOrgTeamAddComponent
  ]
})
export class CaseManagementOrgTeamAddModule { }
